import Styled from './styled';

export default function Methodology() {
  return (
    <Styled className="Methodology">
      <h2>Methodology</h2>
      <div className="content">
        <p>
          The 2020 Parking Price Index shows the cost of parking in 65 cities around the world. The cities
          were selected based on their availability of comparable parking data. The default ranking for index
          is based on the average deviation of the price to park in various locations in each city, most to
          least expensive.
        </p>
        <p>Prices were taken from the following locations in each city:</p>
        <ul>
          <li>Airport</li>
          <li>Shopping District (Car Park)</li>
          <li>Shopping District (Street Parking)</li>
          <li>Stadium</li>
          <li>City Hall</li>
        </ul>

        <p>
          The prices show both the raw price per hour (with the exception of Stadiums, which show the price
          for 3 hours or the flat rate) and as an expression of the percentage deviation from the median.
        </p>
      </div>

      <br />

      <div className="content">
        <h3>
          <b>Airport</b>
        </h3>
        <ul>
          <li>
            For each location, a representative airport was chosen (i.e. one that makes sense for local
            residents).
          </li>
          <li>The price shown is the cost of parking for 1 hour in short-term parking.</li>
          <li>As much as possible, prices were taken from the official airport car park.</li>
          <li>Where possible, prices were collected for a Monday between 14:00-15:00 o&#39;clock.</li>
        </ul>
      </div>

      <br />

      <div className="content">
        <h3>
          <b>Shopping District (Street Parking)</b>
        </h3>
        <ul>
          <li>
            For each location, a representative shopping district was chosen (i.e. one that makes sense for
            local residents).
          </li>
          <li>The price shown is the cost of parking for 1 hour in short-term street parking.</li>
          <li>Where possible, prices were collected for a Monday between 14:00-15:00 o&#39;clock.</li>
          <li>
            Prices collected were for the closest&#42; available street parking. Mostly, the price for street
            parking is divided in zones, but sometimes direct parking metre prices were available.
          </li>
        </ul>
      </div>

      <br />

      <div className="content">
        <h3>
          <b>Shopping District (Car Park)</b>
        </h3>
        <ul>
          <li>
            For each location, a representative shopping district was chosen (i.e. one that makes sense for
            local residents).
          </li>
          <li>The price shown is the cost of parking for 1 hour in short-term street parking.</li>
          <li>Where possible, prices were collected for a Monday between 14:00-15:00 o&#39;clock.</li>
          <li>Prices were collected for the closest&#42; car park.</li>
        </ul>
      </div>

      <br />

      <div className="content">
        <h3>
          <b>Stadium</b>
        </h3>
        <ul>
          <li>
            For each location, a representative stadium was chosen (i.e. one that makes sense for local
            residents, and should also host sporting events on a regular basis).
          </li>
          <li>
            Some stadiums are found outside of the city, for example in Dallas, the AT&T Stadium is located in
            Arlington, not in Dallas, but since it is the home stadium of the Dallas Cowboys and in very close
            proximity to Dallas, this stadium was utilised for the Dallas Stadium price.
          </li>
          <li>
            Prices were collected for the Home Team&#39;s matchday across various sports (such as
            Football/Soccer, American Football, Baseball, etc.)
          </li>
          <li>
            Prices were mostly a flat rate per car per day. If not, the price collected was for 3 hours.
          </li>
          <li>Prices were collected for the closest&#42; car park, or in rare cases street parking.</li>
        </ul>
      </div>

      <br />

      <div className="content">
        <h3>
          <b>City Hall</b>
        </h3>
        <ul>
          <li>For each location, the main city hall was chosen.</li>
          <li>The price shown is the cost of parking for 1 hour in short-term street parking.</li>
          <li>Where possible, prices were collected for a Monday between 14:00-15:00 o&#39;clock.</li>
          <li>Prices were collected for the closest&#42; car park.</li>
        </ul>

        <br />

        <p>
          &#42;Closest means that a parking location should be within 500 metres walking distance to the
          venue, maximum. Obvious distortions were avoided where possible by comparing the price to other
          parking spaces at a similar distance.
        </p>
      </div>

      <br />

      <div className="content">
        <h3>
          <b>&#37; Deviation from Median</b>
        </h3>
        <ul>
          <li>
            In order to determine the deviation from the median price, the price for each location was
            compared to the median price of each location. The deviation from the median is calculated using
            the following formula:
            <br />
            <span className="formula">
              <span>(Xi - Median of location prices)</span>
              <span>Median of location prices</span>
            </span>
            <br />
            <span>For example, the deviation of the parking price of Heathrow Airport (London):</span>
            <span className="formula">
              <span>(Airport Price London - Median Price all Airports)</span>
              <span>Median Price all Airports</span>
            </span>
          </li>
        </ul>
      </div>

      <br />

      <div className="content">
        <h3>
          <b>Average Deviation</b>
        </h3>
        <ul>
          <li>
            The average of all available location deviations (Airport, Shopping District (Street Parking),
            Shopping District (Car Park), Stadium, City Hall) in a city.
          </li>
        </ul>
      </div>

      <br />
      <p>Currency exchange rates correct the average exchange rate between 01.02.2020 and 24.02.2020.</p>
    </Styled>
  );
}
